import 'vant/lib/datetime-picker/index.less'

// 依赖
import '../preview-text/style'
